import { render, staticRenderFns } from "./ShoppingListToggleButton.vue?vue&type=template&id=49ec28ce&scoped=true&"
import script from "./ShoppingListToggleButton.vue?vue&type=script&lang=js&"
export * from "./ShoppingListToggleButton.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingListToggleButton.vue?vue&type=style&index=0&id=49ec28ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ec28ce",
  null
  
)

export default component.exports